import React from "react";
import Features from "./Features";
import About from "./About";
import Steps from "./Steps";
import Team from "./Team";
import Pricing from "./Pricing";
import Testimonial from "./Testimonial";
import Counter from "./Counter";
import Blogs from "./Blogs";
import HeroSection from "./HeroSection";
import Contact from "./Contact"

const PageContent = () => {
	return (
		<>
			<HeroSection />
			<div className="page-content">
				<About />
				<Features />
				<Contact />
			</div>
		</>
	);
};
export default PageContent;
